const { render } = wp.element; //we are using wp.element here!
import App from './App';
if (document.getElementById('spectra-cloud-profile')) { //check if element exists before rendering
  render(<App />, document.getElementById('spectra-cloud-profile'));
}